import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { nanoid } from 'nanoid';
import {
	Sizes,
	generateAnimations,
	destroyAnimations,
	generateTriggers,
} from '../utils';

gsap.registerPlugin( ScrollTrigger );

export class PageScroll {
	constructor( options = {} ) {
		// General
		this.body = document.querySelector( 'body' );
		this.sizes = new Sizes();
		this.options = {
			...options,
			devices: options?.devices || [ 'Desktop', 'Tablet', 'Mobile' ],
			start: options?.start || 'top top',
			end: options?.end || 'bottom bottom',
			offset: options?.offset || 50,
		};
		this.isEnable = false;

		// Animations
		this.timelines = null;
		this.actionTimer = null;

		// Triggers Data
		this.upTrigger = {};
		this.downTrigger = {};
		this.upFn = [];
		this.downFn = [];
		this.triggerTimer = [];

		this.triggerID = `trigger-${ nanoid( 9 ) }`;
		this.prevScroll = window.scrollY;
	}

	init() {
		if (
			this.isEnable ||
			! this.options.devices.includes( this.sizes.device )
		)
			return;
		const [ theTimelines, theTextInstance ] = generateAnimations(
			null,
			this.options.animations
		);
		this.timelines = theTimelines;
		this.textInstances = theTextInstance;

		const upSettings = this.options.scrollUp;
		const DownSettings = this.options.scrollDown;

		this.upFn = generateTriggers(
			upSettings,
			this.timelines,
			this.upTrigger,
			this.triggerTimer,
			0
		);

		this.downFn = generateTriggers(
			DownSettings,
			this.timelines,
			this.downTrigger,
			this.triggerTimer,
			0
		);

		ScrollTrigger.create( {
			trigger: this.body,
			start: this.options.start,
			id: this.triggerID,
			onUpdate: ( self ) => {
				const distance = Math.abs( this.prevScroll - window.scrollY );
				timer.restart( true );
				if ( distance > this.options.offset ) {
					if ( self.direction === 1 ) {
						this.downFn[ 0 ]?.run();
					} else if ( upSettings ) {
						this.upFn[ 0 ]?.run();
					}
				}
			},
		} );
		const timer = gsap.delayedCall( 0.5, () => {
			this.prevScroll = window.scrollY;
		} );
		this.isEnable = true;
	}

	kill() {
		if ( ! this.isEnable ) return;
		destroyAnimations(
			null,
			this.options.animations,
			this.timelines,
			this.textInstances
		);
		ScrollTrigger.getById( this.triggerID )?.kill( true );
		this.timelines = null;
		this.actionTimer = null;
		this.upTrigger = {};
		this.downTrigger = {};
		this.upFn = [];
		this.downFn = [];
		this.triggerTimer = [];
		this.isEnable = false;
	}

	resize() {
		this.kill();
		this.init();
	}

	destroy() {
		this.kill();
		this.body = null;
		this.sizes = null;
		this.options = null;
		this.isEnable = null;
		this.timelines = null;
		this.actionTimer = null;
		this.upTrigger = null;
		this.downTrigger = null;
		this.upFn = null;
		this.downFn = null;
		this.triggerTimer = null;
		this.triggerID = null;
		this.prevScroll = null;
	}
}
